enum DropType {
    DROP_ON_EMPTY_SEAT = 'DROP_ON_EMPTY_SEAT',
    DROP_TICKET = 'DROP_TICKET',
    DROP_ON_CONTAINER = 'DROP_ON_CONTAINER',
    NO_OP = 'NO_OP',
}

enum TicketDropType {
    SAME_TABLE_SWAP = 'SAME_TABLE_SWAP',
    UNSEATED_TO_TABLE_RESHUFFLE = 'UNSEATED_TO_TABLE_RESHUFFLE',
    TABLE_WITH_ROOM_RESHUFFLE = 'TABLE_WITH_ROOM_RESHUFFLE',
    TABLE_FULL = 'TABLE_FULL',
    INVALID = 'INVALID',
}

enum ContainerDropType {
    MULTIPLE_WITH_GROUPS = 'MULTIPLE_WITH_GROUPS',
    MULTIPLE_WITHOUT_GROUPS = 'MULTIPLE_WITHOUT_GROUPS',
    SINGLE_WITH_GROUP = 'SINGLE_WITH_GROUP',
    SINGLE_WITHOUT_GROUP = 'SINGLE_WITHOUT_GROUP',
    INVALID = 'INVALID',
}

enum EmptySeatDropType {
    SINGLE_TO_EMPTY = 'SINGLE_TO_EMPTY',
    SINGLE_TO_OCCUPIED = 'SINGLE_TO_OCCUPIED',
    MULTIPLE_WITH_CAPACITY = 'MULTIPLE_WITH_CAPACITY',
    MULTIPLE_EXCEEDS_CAPACITY = 'MULTIPLE_EXCEEDS_CAPACITY',
    INVALID = 'INVALID',
}

export { DropType, TicketDropType, ContainerDropType, EmptySeatDropType };
